module.exports = __webpack_public_path__ + "img/logo-smtt@2x.c75f373e.png";